import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
  FormControlLabel,
  FormGroup,
  FormControl,
  Radio,
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%',
  },
  formRow: {
    margin: '5px 0',
    justifyContent: 'space-between',
  },
}))

function RadioListFilter({ options, activeValue, setValues }) {
  const { t } = useTranslation()
  const classes = useStyles()

  const onClick = value => () => {
    if (activeValue !== value) setValues(value)
  }

  const renderDisplayComponent = ({ value, label }) => (
    <FormControlLabel
      className={classes.formRow}
      key={label}
      control={
        <Radio
          color="primary"
          checked={activeValue === value}
          onClick={onClick(value)}
          value={value || ""}
        />
      }
      label={t(`filters.valueMappings.${label}`)}
      labelPlacement="start"
    />
  )

  return (
    <FormControl component="fieldset" key="checkbox::form" className={classes.form}>
      <FormGroup>{options.map(renderDisplayComponent)}</FormGroup>
    </FormControl>
  )
}


export default RadioListFilter
